import React, { useEffect, useState } from 'react';
import AddNewTaskProgressNote from 'src/components/TaskProgressNote/AddNewTaskProgressNote';
import HeaderContentBlock from 'src/components/Common/HeaderContentBlock';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { deleteTaskProgressNotes, taskProgressNotesList } from 'src/services/TaskProgressNote';
import ResponsivTaskProgressNoteListAccordion from 'src/components/Responsive/taskProgressNote/ResponsivTaskProgressNoteListAccordion';
import { dateTimeFormate, tokenDecode } from 'src/utils/function';
import ResponsiveHeaderContentBlock from 'src/components/Responsive/ResponsiveHeaderContentBlock';
import ModalContentBlock from 'src/components/Common/ModalContentBlock';
import ConfirmationPopUp from 'src/components/Common/ConfirmationPopUp';
import { toast } from 'react-toastify';
import { FaSpinner, FaTrash } from 'react-icons/fa';
import SortFilterContentModal from 'src/components/Common/SortFilterContentModal';
import TaskProgressNoteSortFilter from 'src/components/TaskProgressNote/TaskProgressNoteSortFilter';
import { useLocation } from 'react-router-dom';
import { Tooltip } from 'flowbite-react';

const TaskProgressNote = () => {
    const [addNewTaskProgressNote, setAddNewTaskProgressNote] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [sortModal, setSortModal] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [page, setPage] = useState(0);
    const [rows, setRows] = useState(50);
    const [first, setFirst] = useState(0);
    const [taskListData, setTaskProgressNoteListData] = useState([]);
    const [totalTaskProgressNoteRecords, setTotalTaskProgressNoteRecords] = useState(0);
    const [openAcoordionResponsive, setOpenAcoordionResponsive] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const [confirnModalOpen, setConfirmModalOpen] = useState<any>({ id: null });
    const [userData, setUserData] = useState<any>({});
    const [filterApply, setFilterApply] = useState(0);
    const [selectedTaskId, setSelectedTaskId] = useState(null);

    const location = useLocation();

    const [filterBy, setFilterBy] = useState({
        dateTo: '',
        dateFrom: '',
        title: '',
    });
    const [dateTo, setDateTo] = useState(null);
    const [formateDateTo, setFormateDateTo] = useState('Start Date To');
    const [dateFrom, setDateFrom] = useState(null);
    const [formateDateFrom, setFormateDateFrom] = useState('Start Date From');

    const dateProps = {
        dateTo,
        formateDateTo,
        dateFrom,
        formateDateFrom,

        setDateTo,
        setFormateDateTo,
        setDateFrom,
        setFormateDateFrom,
    };
    const getToken = async () => {
        const token = await tokenDecode();
        setUserData(token);
    };
    useEffect(() => {
        getToken();
    }, []);
    useEffect(() => {
        setIsLoading(true);
        if (location.state?.id) {
            setFilterBy((prevData: any) => ({
                ...prevData,
                title: location.state.id,
            }));
            setSelectedTaskId(location.state);
            setPage(0);
            setFirst(0);
        }
    }, [location.state?.id]);

    const apiDataCall = () => {
        const controller = new AbortController();
        const signal = controller.signal;
        let isSearch = searchInput ? `&search=${searchInput}` : '';
        let title = location.state?.id ? `&taskId=${location.state.id}` : '';
        let userId = location.state?.userId ? `${location.state?.userId}` : '';
        let isAdmin = location.state?.isAdmin ? `${location.state?.isAdmin}` : '';

        if (filterApply) {
            let startTo = filterBy.dateTo ? `&dateTo=${filterBy.dateTo}` : '';
            let startFrom = filterBy.dateFrom ? `&dateFrom=${filterBy.dateFrom}` : '';

            getList(`?limit=10&page=${page}${isSearch}${startTo}${startFrom}${title}${userId}${isAdmin}`, signal);
        } else {
            getList(`?limit=10&page=${page}${isSearch}${title}${userId}${isAdmin}`, signal);
        }

        return () => controller.abort();
    };

    useEffect(() => {
        apiDataCall();
    }, [page, searchInput, rows, filterApply, location.state?.id]);

    const getList = async (url: string, signal?: any) => {
        try {
            setIsLoading(true);
            const resData = await taskProgressNotesList(url, signal);
            const data = resData?.data?.data;
            setTaskProgressNoteListData(data.tasks);
            setTotalTaskProgressNoteRecords(data.total);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };
    const handleRowClick = (row: any) => {
        if (userData?.permissions?.includes('task_progress_note_update')) {
            setIsUpdate(true);
            setAddNewTaskProgressNote(true);
            setSelectedRowData(row.data);
        }
    };
    const handleFilterClear = () => {
        setPage(0);
        setFirst(0);
        setSortModal(false);
        setFilterApply(0);

        setFilterBy({
            dateTo: '',
            dateFrom: '',
            title: '',
        });
        setSelectedTaskId(null);

        setFormateDateTo('Start Date To');
        setDateTo(null);
        setFormateDateFrom('Start Date From');
        setDateFrom(null);
    };
    const handleFilterApply = () => {
        setPage(0);
        setFilterApply(filterApply + 1);
        setSortModal(false);
    };

    const handleSearch = (e: any) => {
        setPage(0);
        setSearchInput(e.target.value);
    };
    const newTaskProgressNoteSuccess = () => {
        if (page === 0) {
            apiDataCall();
        } else {
            setPage(0);
            setFirst(0);
        }
        setAddNewTaskProgressNote(false);
        setBtnDisabled(false);
        setIsUpdate(false);
        setSelectedRowData(null);
    };
    const onPageChange = (event: any) => {
        setFirst(event.first);
        setRows(event.rows);
        setPage(event.page);
    };

    const GetTitle = (row: any) => <div>{row?.title}</div>;
    const GetNote = (row: any) => <div>{row?.note || row?.note !== '' ? row?.note : '-'}</div>;
    const GetCreatedBy = (row: any) => <div>{row?.createdBy}</div>;

    const GetDeleteAction = (row: any) => (
        <div
            onClick={(e) => {
                e.stopPropagation();
                setConfirmModalOpen({ id: row.id });
            }}
            className=" p-2 bg-red-100 text-red-700 rounded-lg justify-center items-center inline-flex"
        >
            <FaTrash size={14} />
            {/* <p className="text-xs font-medium ">Delete</p> */}
        </div>
    );
    const GetDate = (row: any) => <div>{row.date ? dateTimeFormate(row.date, 'DD MMM, YYYY') : '-'}</div>;
    const handleDeleteClick = async (id: any) => {
        try {
            const res = await deleteTaskProgressNotes(`?progressNoteId=${id}`);

            if (res?.status === 200) {
                toast.success(`Task deleted successfully.`);
                let userId = location.state?.userId ? `${location.state?.userId}` : '';
                let isAdmin = location.state?.isAdmin ? `${location.state?.isAdmin}` : '';
                if (searchInput) {
                    getList(`?page=${page}&limit=${rows}&search=${searchInput}${userId}${isAdmin}`);
                } else {
                    getList(`?page=${page}&limit=${rows}${userId}${isAdmin}`);
                }
            } else {
                toast.error(res?.data?.message || 'Operation failed. Please try again.');
            }
        } catch (err) {
            // console.log(err);
        }
        setConfirmModalOpen({ id: null });
    };
    const GetEmpList = (row: any) => {
        if (row?.empIds === undefined || row?.empIds === null || row?.empIds === '[]') {
            return '-';
        }
        const employee = () => (
            <div>
                {row.empList
                    ?.filter((data: any) => data?.name || data?.surname)
                    .map((data: any, index: number) => (
                        <p className="truncate" key={index}>
                            {data.name && data.surname ? `${data.name} ${data.surname}` : `${data.name ?? ''} ${data.surname ?? ''}`.trim()}
                        </p>
                    ))}
            </div>
        );

        if (row?.empList?.length === 0) {
            return '-';
        }

        return row?.empList?.length === 1 ? (
            <p className="truncate">{`${row.empList[0].name} ${row.empList[0].surname}`}</p>
        ) : (
            <div className="flex">
                <p className="truncate me-[6px]">{`${row.empList[0].name} ${row.empList[0].surname}..`}</p>
                <Tooltip className="bg-black text-white" content={<>{employee()}</>}>
                    <div className="w-4 h-4 px-2 pt-0.5 pb-1 bg-indigo-500 rounded-2xl flex-col justify-center items-center gap-2 inline-flex">
                        <div className="text-white text-xs font-medium font-['Satoshi Variable']">{row?.empList?.length}</div>
                    </div>
                </Tooltip>
            </div>
        );
    };

    return (
        <div>
            <div>
                <ResponsiveHeaderContentBlock
                    // sortOnClick={() => setSortModal(true)}
                    closeOnClick={() => {
                        setAddNewTaskProgressNote(false);
                        setSelectedRowData(null);
                        setIsUpdate(false);
                    }}
                    addNewOnClick={() => setAddNewTaskProgressNote(true)}
                    isDisabled={addNewTaskProgressNote}
                    searchOnchange={handleSearch}
                    searchInput={searchInput}
                    isNext={addNewTaskProgressNote}
                    isSave={userData?.permissions?.includes('task_progress_note_create') ? true : false}
                />
            </div>
            <HeaderContentBlock
                closeOnClick={() => {
                    setAddNewTaskProgressNote(false);
                    setSelectedRowData(null);
                    setIsUpdate(false);
                }}
                saveOnClick={() => setIsSave(true)}
                addNewOnClick={() => setAddNewTaskProgressNote(true)}
                nextStep={addNewTaskProgressNote}
                addNewBtnText={'Add new Task Progress Note'}
                isEmploy={true}
                headerText="Task Progress Notes"
                isDisabled={btnDisabled}
                searchOnchange={handleSearch}
                searchInput={searchInput}
                isSave={userData?.permissions?.includes('task_progress_note_create') ? true : false}
                // sortOnClick={() => setSortModal(true)}
            />
            {addNewTaskProgressNote && selectedTaskId && (
                <AddNewTaskProgressNote
                    setIsSave={setIsSave}
                    isSave={isSave}
                    isOnSuccess={() => {
                        newTaskProgressNoteSuccess();
                    }}
                    setBtnDisabled={setBtnDisabled}
                    btnDisabled={btnDisabled}
                    isUpdate={isUpdate}
                    selectedRowData={selectedRowData}
                    selectedTaskId={selectedTaskId}
                />
            )}
            <div className={`pt-5 pb-0 w-full ${addNewTaskProgressNote ? 'hidden' : 'max-lg:block hidden'}`}>
                <>
                    {isLoading ? (
                        <div className="flex items-center justify-center 200 h-screen bg-gray-50">
                            <div className="text-center text-gray-500 text-lg font-medium">
                                <FaSpinner className="animate-spin text-2xl text-gray-600" />
                            </div>
                        </div>
                    ) : (
                        <>
                            {taskListData?.length === 0 && (
                                <div
                                    className=" bg-white max-md:h-10 flex justify-center items-center max-lg:font-semibold
                         max-lg:text-xl max-lg:h-12  max-md:font-medium max-md:text-lg"
                                >
                                    No Task Progress Note Found
                                </div>
                            )}

                            <ResponsivTaskProgressNoteListAccordion
                                taskListData={taskListData}
                                openAcoordionResponsive={openAcoordionResponsive}
                                setOpenAcoordionResponsive={setOpenAcoordionResponsive}
                                onRowClick={handleRowClick}
                                GetDeleteAction={GetDeleteAction}
                                userData={userData}
                                GetEmpList={GetEmpList}
                            />
                            <div className="mt-5">
                                <Paginator
                                    first={first}
                                    rows={rows}
                                    totalRecords={totalTaskProgressNoteRecords}
                                    onPageChange={onPageChange}
                                    className="datatable_pagination"
                                    template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                />
                            </div>
                        </>
                    )}
                </>
            </div>
            <div className="py-6 hidden lg:block">
                <DataTable value={taskListData} tableClassName="logdatatable" emptyMessage="No Task Progress Note Found" className="" loading={isLoading} onRowClick={handleRowClick}>
                    <Column field="title" header="Title" body={GetTitle}></Column>
                    <Column field="note" header="Note" body={GetNote}></Column>
                    <Column field="date" header="Date" body={GetDate}></Column>
                    <Column field="createdBy" header="Created By" body={GetCreatedBy}></Column>
                    <Column field="empList" header="Employees" body={GetEmpList}></Column>
                    {userData?.permissions?.includes('task_progress_note_delete') && <Column field="action" header="Action" body={GetDeleteAction}></Column>}
                </DataTable>
                <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalTaskProgressNoteRecords}
                    onPageChange={onPageChange}
                    className="datatable_pagination"
                    template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                />
                {sortModal && (
                    <SortFilterContentModal
                        setSortModal={setSortModal}
                        onFilterClear={handleFilterClear}
                        onFilterApply={handleFilterApply}
                        isJob={true}
                        isModalOpen={sortModal}
                        customClass={'!w-[450px]'}
                    >
                        <TaskProgressNoteSortFilter dateProps={dateProps} filterBy={filterBy} setFilterBy={setFilterBy} setSelectedTaskId={setSelectedTaskId} />
                    </SortFilterContentModal>
                )}
            </div>
            {confirnModalOpen.id && confirnModalOpen.id !== null && (
                <ModalContentBlock onclose={() => setConfirmModalOpen({ id: null })} isMoreClass="logout_modal" isModalOpen={confirnModalOpen}>
                    <ConfirmationPopUp
                        confirmText="Are you sure you want to delete this Task Progress Note?"
                        submitOnClick={() => {
                            handleDeleteClick(confirnModalOpen.id);
                        }}
                        cancelOnClick={() => setConfirmModalOpen({ id: null })}
                    />
                </ModalContentBlock>
            )}
        </div>
    );
};

export default TaskProgressNote;
